class MathHelper {
    public static roundToDecimals(value: number, numberOfDecimals: number = 2): number {
        const factor = Math.pow(10, numberOfDecimals);
        return value && Math.round(value * factor) / factor;
    }
}

export { MathHelper };
